import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useAppOptions } from './use-app-options';

let scrolledAfterMount = false;

const useScrollToTop = () => {
    const { pathname } = useLocation();
    const { rootElementId, scrollToViewOnMount, scrollTopOffsetPx } = useAppOptions('main');

    useEffect(() => {
        if (!scrollToViewOnMount && !scrolledAfterMount) {
            scrolledAfterMount = true;
            return;
        }

        const rootElement = document.getElementById(rootElementId);
        const navBar = document.querySelector<HTMLElement>('.vmd__header');
        const navBarOffsetHeight = navBar ? navBar.offsetHeight : 0;
        const adjustedOffsetPx = scrollTopOffsetPx ? scrollTopOffsetPx + navBarOffsetHeight : navBarOffsetHeight;

        if (rootElement) {
            const y = rootElement.getBoundingClientRect().top + window.pageYOffset - adjustedOffsetPx;

            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    }, [pathname, rootElementId, scrollToViewOnMount, scrollTopOffsetPx]);
};

export { useScrollToTop };
